<template>
  <div class="sidebar" id="sidenavbar" style="height:100vh;">
    <div class="sidebar" style="height:inherit">
      <div class="sidebar-nav">
        <div class="row image">
          <div class="col pt-2" style="borderBottom:2px solid #DEDEDE;">
            <div class="logo-wrapper text-center pb-3">
              <a href="#">
                <img
                  src="../../assets/Ambee1.png"
                  class="img-responsive text-center"
                  style="width:200px"
                />
              </a>
            </div>
          </div>
        </div>
        <div class="list-group text-center" role="tablist">
          <router-link
            :class="[currentPage.includes('cust') ? navactiveClass: '', 'list-group-item list-group-item-action mt-2 p-2']"
            data-toggle="list"
            to="/cust"
          >Customers</router-link>
          <router-link
            :class="[currentPage.includes('devices') || currentPage.includes('search')? navactiveClass: '', 'list-group-item list-group-item-action mt-2 p-2']"
            data-toggle="list"
            :to="routeTo"
          >All Devices</router-link>
          <router-link
            :class="[currentPage.includes('reports') ? navactiveClass: '', 'list-group-item list-group-item-action mt-2 p-2']"
            data-toggle="list"
            to="/reports"
          >Reports</router-link>
          <router-link
            v-if="roleId==3"
            :class="[currentPage.includes('update') ? navactiveClass: '', 'list-group-item list-group-item-action mt-2 p-2']"
            data-togle="list"
            to="/updateInfo"
          >Update</router-link>
          <router-link
            v-if="roleId==3"
            :class="[currentPage.includes('home') ? navactiveClass: '', 'list-group-item list-group-item-action mt-2 p-2']"
            data-toggle="list"
            to="/home"
          >Main menu</router-link>
        </div>
        <div class="logout" style="borderTop:2px solid #DEDEDE">
          <button class="btn logout-btn p-1" @click="logout">
            <i class="fas fa-sign-out-alt" aria-hidden="true"></i>
            Logout
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AUTH_LOGOUT } from "../../store/actions/auth";

export default {
  data() {
    return {
      roleId: parseInt(JSON.parse(localStorage.getItem("user")).roleId),
      navactiveClass: "activebg",
      routeTo : parseInt(JSON.parse(localStorage.getItem("user")).roleId) === 3 ? '/search' : '/devices'
    };
  },
  computed: {
    currentPage() {
      return this.$route.path;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push("/login"));
    },
  },
};
</script>
<style>
.list-group-item {
  border: none;
  font-size: 1rem;
  /* font-family: Ubuntu-Medium; */
  /* text-align: justify; */
}

.sidebar {
  background: #fff;
  box-shadow: 6px 0 14px 0 rgba(0, 0, 0, 0.1);
  font-family: Ubuntu;
  font-weight: 500;
  font-size: 15px;
  position: fixed;
  color: rgba(59, 59, 59, 0.8);
}
/* .list-group-item.active {
  background: #2295c8 !important;
  border-radius: 6.2rem 0 0 6.2rem;
} */
.list-group-item:hover {
  background-color: #dbf3fa;
}
.list-group {
  padding-left: 1rem;
}
.logout {
  text-align: center !important;
  width: 100%;
  position: absolute;
  bottom: 0;
  right: 0;
  /* border-radius: 15px 0px 0px 15px; */
}
.logout:hover {
  background-color: #cc0202;
}
.logout-btn {
  font-family: Ubuntu;
  font-weight: 500;
  color: rgba(59, 59, 59, 0.8);
  background-color: transparent;
}
.logout-btn:hover {
  color: white;
}
router-link {
  padding: 1 !important;
}
.image {
  margin-right: 0px;
}
.activebg {
  background: #2295c8 !important;
  border-radius: 6.5rem 0 0 6.5rem !important;
  color: white;
}
</style>
